import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, IUser } from "src/services/types";
import { getUsers } from "src/services/users-service";
import { ColumnsUsersByGroups } from "./ColumnsUsersByGroups";
import { toast } from 'react-toastify';
import { SearchTable } from "src/components/Common/SearchTable";
import { Card, CardBody, Col, Row } from "reactstrap";
import { OccupationFilter } from "../Users/OccupationFilter";
import { EditUserModal } from "../Users/EditUserModal";
import { DetailsUserModal } from "../Users/DetailsUserModal";
import { ConfirmValidateModal } from "../UsersToValidate/ConfirmValidateModal";
import { ConfirmRejectModal } from "../UsersToValidate/ConfirmRejectModal";
import { ConfirmDeleteModal } from "../UsersToValidate/ConfirmDeleteModal";
import { GroupModal } from "../UsersToValidate/GroupModal";
import { NoteModal } from "../UsersToValidate/NoteModal";
import { GroupFilter } from "../Users/GroupFilter";
import { ConfirmReturnToReviewModal } from "../RejectedUsers/ConfirmReturnToReviewModal";
import { AdminVerifiedFilter } from "../Users/AdminVerifiedFilter";

export const UsersByGroup = () => {
    document.title = "Secure | Users by Group";

  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState<IUser[]>([]);
  const [userSelected, setUserSelected] = useState<IUser | null>(null);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 10,
      search: "",
      occupation_id: "",
      group_id: "",
      is_verified_by_admin: '',
  });
  const [showValidateModal, setShowValidateModal] = useState(false);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showMoveToGroupModal, setShowMoveToGroupModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showReturnToReviewModal, setShowReturnToReviewModal] = useState(false);

  const fetchData = async (config: IConfig) => {
    setIsLoading(true);
    const configAux = { ...config };
    if(configAux.is_verified_by_admin === 'all') {
      delete configAux.is_verified_by_admin;
    }
    const res = await getUsers(configAux, 'all')
    setIsLoading(false);
    if (res.result === 'ok') {
        setTotalRows(res.data.pagination.total);
        setUsers(res.data.data);
        setTotalPage(res.data.pagination.total_pages);
        if(forceUserSelected === 'first') {
          openModal(res.data.data[0], res?.data?.data || []);
        } 
        if(forceUserSelected === 'last') {
          openModal(res.data.data[res.data.data.length - 1], res?.data?.data || []);
        }
        setForceUserSelected(null);
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }

  const onValidate = async (item: IUser) => {
    setUserSelected(item);
    setShowValidateModal(true);
  }

  const onReject = async (item: IUser) => {
    setUserSelected(item);
    setShowRejectedModal(true);
  }

  const onDelete = async (item: IUser) => {
    setUserSelected(item);
    setShowDeletedModal(true);
  }

  const openModal = async (item: IUser, usersAux: IUser[] = [] ) => {
    setUserSelected(item);
    setShowUserDetailModal(true);
    if(usersAux.length > 0) {
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
    }
    if((item?.id == (usersAux.length > 0 ? usersAux[0]?.id : users[0]?.id)) && (config.page == 1)) {
      setButtonPrevDisabled(true);
    } else {
      setButtonPrevDisabled(false);
    }

    if((item?.id == (usersAux.length > 0 ? usersAux[usersAux.length - 1]?.id : users[users.length - 1]?.id)) && (config.page == totalPage)) {
      setButtonNextDisabled(true);
    } else {
      setButtonNextDisabled(false);
    }
  }

  const openNoteModal = async (item: IUser) => {
    setUserSelected(item);
    setShowNoteModal(true);
  }

  const onMoveAGroup = async (item: IUser) => {
    setUserSelected(item);
    setShowMoveToGroupModal(true);
  }
  
  const refresh = () => {
    fetchData(config);
  }
  
  const handleChangeOccupation = (occupationId: string) => {
    setConfig({ ...config, occupation_id: occupationId, page: 1 });
  }
  
  const handleChangeGroup = (groupId: string) => {
    setConfig({ ...config, group_id: groupId, page: 1 });
  }

  const handleChangeAdminVerified = (adminVerified: string) => {
    let verifiedByAdmin: null|boolean|string = 'all';
    if(adminVerified === 'true') {
      verifiedByAdmin = true;
    }
    if(adminVerified === 'false') {
      verifiedByAdmin = false;
    } 
    if(adminVerified === 'null') {
      verifiedByAdmin = 'null';
    }
    if(adminVerified === 'all') {
      verifiedByAdmin = 'all';
    }

      setConfig({ ...config, is_verified_by_admin: verifiedByAdmin, page: 1 });
  }
  
  const openEditUserModal = async (item: IUser) => {
    setUserSelected(item);
    setShowEditUserModal(true);
  }
  
  const onReturnToReview = async (item: IUser) => {
    setUserSelected(item);
    setShowReturnToReviewModal(true);
  }
  
  const [forceUserSelected, setForceUserSelected] = useState<'last' | 'first' | null>(null);
  const [buttonNextDisabled, setButtonNextDisabled] = useState(false);
  const [buttonPrevDisabled, setButtonPrevDisabled] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  
  const onPrevUser = async() => {
    setButtonNextDisabled(false);
    const index = users.findIndex(u => u.id === userSelected?.id);
    if (index > 0) {
      setUserSelected(users[index - 1]);
    } else if (config.page > 1) {
      setForceUserSelected('last');
      setShowUserDetailModal(false);
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
      setConfig({ ...config, page: config.page - 1 });
    }
    if(index === 1 && config.page === 1) {
      setButtonPrevDisabled(true);
    }
  }
  const onNextUser = async() => {
    setButtonPrevDisabled(false);
    const index = users.findIndex(u => u.id === userSelected?.id);
    if (index < users.length - 1) {
      setUserSelected(users[index + 1]);
    } else {
      setForceUserSelected('first');
      setShowUserDetailModal(false);
      await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
      setConfig({ ...config, page: config.page + 1 });
    }
  }
  
  useEffect(() => {
    fetchData(config);
  }, [config]);

  return (
    <>
      <div className="page-content">
          <h2 className="text-primary mb-3">Users by Group</h2>

          <Card>
            <div className="m-2 text-muted">Filters</div>
            <CardBody className="pt-0">
              <Row className="gap-2">
                <Col sm={3} className="d-flex align-items-center justify-content-start">
                  <OccupationFilter
                    onOccupationChange={handleChangeOccupation}
                    label="Occupation"
                  />
                </Col>
                <Col sm={3} className="d-flex justify-content-start align-items-center" >
                  <GroupFilter
                    onChange={handleChangeGroup}
                    label="Group"
                  />
                </Col>
                <Col sm={3} className="d-flex align-items-center justify-content-start">
                  <AdminVerifiedFilter
                    onChange={handleChangeAdminVerified}
                    label="Admin Verified"
                  />
                </Col>
                <Col sm={3} className="d-flex justify-content-start align-items-end" >
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row className="mb-2">
            <Col sm={6} className="d-flex align-items-end justify-content-start gap-2">
                <button
                    type="button"
                    className="btn btn-soft-primary waves-effect waves-light"
                    onClick={refresh}
                >
                    <i className="fas fa-sync-alt"></i> Refresh table
                </button>
            </Col>
            <Col sm={6} className="d-flex justify-content-end align-items-end" >
                <div className="w-75">
                  <SearchTable 
                      onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                      loading={isLoading && !!config.search}
                      className=""
                  />
                </div>
            </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                  customStyles={{
                    rows: { style: { minHeight: '50px' }},
                    table: { style: { minHeight: '400px'}},
                    cells: { style: { paddingLeft: '8px', paddingRight: '8px' }},
                  }}
                  columns={ColumnsUsersByGroups(
                    config, 
                    onValidate, 
                    onReject, 
                    openModal, 
                    onDelete, 
                    onMoveAGroup, 
                    openNoteModal,
                    openEditUserModal,
                    onReturnToReview
                  )}
                  data={users}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  responsive
                  onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                  onChangePage={(page) => setConfig({ ...config, page })}
                  paginationDefaultPage={config.page}
                  paginationPerPage={config.per_page}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  noDataComponent={
                      <SectionNoData
                          onRefresh={() => fetchData(config)}
                          isLoading={isLoading}
                      />
                  }
              />
          </ContentDataTable>
      </div>
      {
        userSelected && 
        <DetailsUserModal
            activeButtonsNextPrev
            show={showUserDetailModal}
            onClose={() => (setUserSelected(null), setShowUserDetailModal(false))}
            userId={userSelected?.id!}
            onPrev={onPrevUser}
            onNext={onNextUser}
            buttonNextDisabled={buttonNextDisabled}
            buttonPrevDisabled={buttonPrevDisabled}
        />
      }

      <ConfirmValidateModal
          show={showValidateModal}
          onClose={() => setShowValidateModal(false)}
          onRefresh={refresh}
          user={userSelected!}
      />

      <ConfirmRejectModal
          show={showRejectedModal}
          onClose={() => setShowRejectedModal(false)}
          onRefresh={refresh}
          user={userSelected!}
      />

      <ConfirmDeleteModal
          show={showDeletedModal}
          onClose={() => setShowDeletedModal(false)}
          onRefresh={refresh}
          user={userSelected!}
      />

      <GroupModal 
          show={showMoveToGroupModal}
          onClose={() => setShowMoveToGroupModal(false)}
          onRefresh={refresh}
          item={userSelected!}
      />

      <NoteModal 
          show={showNoteModal}
          onClose={() => setShowNoteModal(false)}
          onRefresh={refresh}
          item={userSelected!}
      />

      <EditUserModal 
          show={showEditUserModal}
          onClose={() => setShowEditUserModal(false)}
          onRefresh={refresh}
          item={userSelected!}
      />

      <ConfirmReturnToReviewModal
          show={showReturnToReviewModal}
          onClose={() => setShowReturnToReviewModal(false)}
          onRefresh={refresh}
          user={userSelected!}
      />

    </>
  )
}